// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__343zD","checkboxCol":"Table_checkboxCol__13x4C","emailCol":"Table_emailCol__31Y9_","actionCol":"Table_actionCol__1Jtiv"};